import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Navbar from "../header/Navbar";
import Timer from "./Timer";
import "./latesttask.scss";
import { API_URL } from '../../../utils/ApiUrl';
import Loader from '../../../hooks/loader';
// import { toast } from 'react-toastify';
import Environment from '../../../utils/Environment';
import { io } from 'socket.io-client';
import { useSocket } from '../../../contexts/SocketContext';
import { useWeb3React } from "@web3-react/core";
import TaskStatus from "./TaskStatus";
import ConditionalLink from "../../../helper/Components/ConditionalLink";
import { tokenImages } from "../../../constants/tokenImages";
import CustomToast from '../../../components/CustomToast';
import { intitial_production_eth_id } from "../../../constants/id";



const LatestTask = () => {
  const [tasks, setTasks] = useState([]);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const catId = searchParams.get('catId'); // Get the 'catId' parameter
  console.log('latesttaskcatId')
  const [userId, setUserId] = useState(0);
  const [visibleTasks, setVisibleTasks] = useState(3);
  const [categoryId, setCategoryId] = useState(null);  // null means 'All tasks'
  const socket = useSocket();
  const [categories, setCategories] = useState([{
    categoryName: "Logistics & Supply Chain",
    id: 15
  }]);
  const { account } = useWeb3React();
  let accessToken = localStorage.getItem('accessToken');
  const [loader, setLoader] = useState(false);

  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(0);

  const [alllcount, setAllTaskCount] = useState(null)

  const handlePageChange = (e) => {
    // console.log("called");
    const selectedPage = e.selected;
    setPage(selectedPage);
    window.scrollTo(0, 0)
  };

  const history = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    let userId = localStorage.getItem("userId");
    setUserId(userId);
  }, []);


  // Function to fetch tasks from the API
  // const getTasks = async ({
  //   limit = 10,
  //   offset = { page },
  //   categoryId = null,
  //   orderField = "createdAt",
  //   orderDirection = "DESC",
  // } = {}) => {
  //   setLoader(true);
  //   const accessToken = localStorage.getItem("accessToken");

  //   // Construct query parameters
  //   const queryParams = new URLSearchParams({
  //     limit,
  //     offset,
  //     orderField,
  //     orderDirection,
  //   });

  //   if (categoryId || catId) {
  //     let cID = categoryId || catId
  //     queryParams.append("categoryId", cID); // Only include if categoryId is provided
  //   }

  //   try {
  //     const response = await fetch(
  //       `${API_URL}tasks?${queryParams.toString()}`,
  //       {
  //         method: "GET",
  //         headers: {
  //             "Content-Type": "application/json",
  //           },
  //       }
  //     );

  //     if (response.ok) {
  //       const data = await response.json();
  //       // console.log(data, 'datadata');
  //       setLoader(false);
  //       if (history.pathname === "/") {
  //         setTasks(data?.data?.tasks?.slice(0, 9) || []); // Limit to 9 tasks
  //       } else {
  //         setTasks(data?.data?.tasks || []);
  //         setPageCount(data?.data?.pages);
  //         setLoader(false); // Set tasks in state
  //       }
  //     } else {
  //       // toast.error("Something went wrong!");
  //       console.error("Failed to fetch tasks:", response.statusText);
  //       setLoader(false);
  //     }
  //   } catch (error) {
  //     console.error("Error occurred while fetching tasks:", error);
  //     setLoader(false);
  //     toast.error(error?.message);
  //   }
  // };
  const getTasks = async ({
    limit = 10,
    offset = { page },
    categoryId = null,
    orderField = "createdAt",
    orderDirection = "DESC",
    currency = ["TASK"], // Default currency for first call
  } = {}) => {
    setLoader(true);
    const accessToken = localStorage.getItem("accessToken");

    // Construct query parameters for first call (3 tasks + currency)
    const queryParams1 = new URLSearchParams({
      limit: 3,
      offset: 1,
      orderField,
      orderDirection,
      currency,
    });

    // Construct query parameters for second call (paginated)
    const queryParams2 = new URLSearchParams({
      limit,
      offset,
      orderField,
      orderDirection,
    });

    if (categoryId) {
      queryParams1.append("categoryId", categoryId);
      queryParams2.append("categoryId", categoryId);
    }

    try {
      const [response1, response2] = await Promise.all([
        fetch(`${API_URL}tasks?${queryParams1.toString()}`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }),
        fetch(`${API_URL}tasks?${queryParams2.toString()}`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }),
      ]);

      if (!response1.ok || !response2.ok) {
        console.error("Failed to fetch tasks:", response1.statusText, response2.statusText);
        setLoader(false);
        return;
      }

      const [data1, data2] = await Promise.all([response1.json(), response2.json()]);

      const combinedTasks = [...(data1?.data?.tasks || []), ...(data2?.data?.tasks || [])];

      setLoader(false);

      if (history.pathname === "/") {
        setTasks(combinedTasks.slice(0, 9)); // Show only 9 tasks on home
      } else {
        setTasks(combinedTasks);
        setPageCount(data2?.data?.pages);
      }
    } catch (error) {
      console.error("Error occurred while fetching tasks:", error);
      setLoader(false);
      // toast.error(error?.message);
       CustomToast.show('error', 'Error!', error?.message);

    }
  };

  const fetchTasksCategories = async () => {
    try {
      const response = await fetch(`${API_URL}tasks-categories?limit=${50}`, {
        method: "GET", // HTTP method
        headers: {
          "Content-Type": "application/json", // Set the content type if needed
          // No authorization header needed since you're not using an access token
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setCategories(data?.data?.taskCategories);
      setAllTaskCount(data?.data?.taskCounts);
      // console.log(data?.data, 'datasdDS'); // Handle your data here
    } catch (error) {
      console.error("Error fetching tasks categories:", error);
    }
  };
  const handleSeeMore = () => {
    setVisibleTasks((prevVisibleTasks) => prevVisibleTasks + 3);
  };
  // Call `getTasks` when the component mounts and whenever `categoryId` changes
  useEffect(() => {
    getTasks({ limit: 9, offset: page + 1, categoryId });
  }, [categoryId, page]);
  // useEffect(() => {
  //   if (catId){
  //     setCategoryId(catId)
  //   }
  // }, [catId])

  // Handle category selection
  const handleCategorySelect = (categoryId) => {
    setPage(0)
    setCategoryId(categoryId); // Update the selected category
  };
  useEffect(() => {
    fetchTasksCategories();
  }, []);
  // console.log(history?.pathname, 'history?.pathname');
  // const getSocket = async (val) => {


  //   const socket = io(API_URL, {
  //     transports: ["websocket", "polling"],
  //     auth: {
  //       Authorization: `Bearer ${val}`,
  //     },
  //   });


  //   socket.on('disconnect', () => {
  //     console.log('disconnected to the server');
  //   });


  //   socket.on('connect', () => {
  //     console.log('Socket Connected to the server');
  //   });

  //   socket.on('NEW_NOTIFICATION_ALERT', (event) => {
  //     console.log('Socket connected in', event);
  //     getTasks({ limit: 9, offset: page + 1, categoryId });
  //   });

  //   socket.on('error', (error) => {
  //     console.error('Connection error: ', error.message); // Handle connection errors
  //   });

  //   // Store the socket instance in localStorage, if necessary.
  //   // This can be useful to manually disconnect the socket when needed.
  //   localStorage.setItem('socketInstance', JSON.stringify(socket));
  // }

  // useEffect(() => {
  //   if (accessToken) {
  //     // getSocket(accessToken);
  //   }
  // }, [accessToken]);
  useEffect(() => {
    if (socket) {
      // Handle the 'NOTIFICATION_ALERT' event here
      socket.on('NEW_NOTIFICATION_ALERT', (event) => {
        // console.log('New notification event in latesttask:', event);
        // You can update your state with new notifications
        getTasks({ limit: 9, offset: page + 1, categoryId });
      });
    }

    // Cleanup event listener on component unmount
    // return () => {
    //   if (socket) {
    //     socket.off('NEW_NOTIFICATION_ALERT');
    //   }
    // };
  }, [socket]);

  const [showAll, setShowAll] = useState(false);

  const toggleShowMore = () => setShowAll(!showAll);
  return (
    <>
      {loader && <Loader />}
      <div className="wrapper-latestsection">
        {/* {history.pathname === '/latesttask' && <Navbar />} */}
        <section className={history.pathname === '/latesttask' ? "latest-task latesttask-section" : "latest-task"} id='latesttask'>
          <div className="custom-container">
            {history.pathname === '/latesttask' && (
              <div className="breadcrumb-text">
                <Link to="/">Home</Link>
                <span>/</span>
                <Link to="/latesttask" className='active'>Tasks</Link>
              </div>
            )}
          </div>

          <div className="main-heading">
            <div className="custom-container">
              <div className="parent-head">
                <h6>
                  {history.pathname === "/latesttask"
                    ? catId ? tasks?.[0]?.tasksCategory?.categoryName : "Tasks"
                    : "Latest Tasks"}
                </h6>
                <Link to="/latesttask" className="btn-view">
                  View All Tasks
                </Link>
              </div>
              <div className="choice-bar">
                {catId ? null : <ul className="nav nav-tabs" id="myTab" role="tablist">
                  {/* All Tasks Button */}
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="all-tasks-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#all-tasks-tab-pane"
                      type="button"
                      role="tab"
                      aria-controls="all-tasks-tab-pane"
                      aria-selected="true"
                      onClick={() => handleCategorySelect(null)} // 'null' for All tasks
                    >
                      All tasks <span>{alllcount}</span>
                    </button>
                  </li>

                  {/* Dynamically generated category buttons */}
                  {categories?.slice(0, showAll ? categories.length : 10)?.map((category, index) => (
                    <li className="nav-item" role="presentation" key={index}>
                      <button
                        className="nav-link"
                        id={`${category?.categoryName
                          ?.toLowerCase()
                          .replace(/ & | /g, "-")}-tab`} // Unique id
                        data-bs-toggle="tab"
                        data-bs-target={`#${category?.categoryName
                          ?.toLowerCase()
                          .replace(/ & | /g, "-")}-tab-pane`}
                        type="button"
                        role="tab"
                        aria-controls={`${category?.categoryName
                          ?.toLowerCase()
                          .replace(/ & | /g, "-")}-tab-pane`}
                        aria-selected="false"
                        onClick={() => handleCategorySelect(category?.id)} // Using index + 1 as ID
                      >
                        {category?.categoryName} <span>{category?.tasksCount}</span>
                      </button>
                    </li>
                  ))}
                  {categories?.length > 10 && (
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        type="button"
                        onClick={() => setShowAll(!showAll)}
                      >
                        {
                          !showAll ? <>
                            Show More <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
                              <path d="M1.66667 4L5.33333 7.66667L9 4" stroke="#013159" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </> : <>
                            Show Less <svg style={{ transform: "rotate(180deg)" }} xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
                              <path d="M1.66667 4L5.33333 7.66667L9 4" stroke="#013159" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </>
                        }
                      </button>
                    </li>
                  )}
                </ul>
                }
                {/* <ul className="nav nav-tabs" id="myTab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true"
                                                onClick={() => handleCategorySelect(null)}  // 'null' for All tasks
                                            >All tasks</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link" id="music-tab" data-bs-toggle="tab" data-bs-target="#music-tab-pane" type="button" role="tab" aria-controls="music-tab-pane" aria-selected="false"
                                                onClick={() => handleCategorySelect(1)}  // Category ID 1 for Music
                                            >Music</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link" id="marketing-tab" data-bs-toggle="tab" data-bs-target="#marketing-tab-pane" type="button" role="tab" aria-controls="marketing-tab-pane" aria-selected="false"
                                                onClick={() => handleCategorySelect(2)}  // Category ID 2 for Marketing
                                            >Marketing</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link" id="design-tab" data-bs-toggle="tab" data-bs-target="#design-tab-pane" type="button" role="tab" aria-controls="design-tab-pane" aria-selected="false"
                                                onClick={() => handleCategorySelect(3)}  // Category ID 3 for Design
                                            >Design</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link" id="media-tab" data-bs-toggle="tab" data-bs-target="#media-tab-pane" type="button" role="tab" aria-controls="media-tab-pane" aria-selected="false"
                                                onClick={() => handleCategorySelect(4)}  // Category ID 4 for Media
                                            >Media</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link" id="crypto-tab" data-bs-toggle="tab" data-bs-target="#crypto-tab-pane" type="button" role="tab" aria-controls="crypto-tab-pane" aria-selected="false"
                                                onClick={() => handleCategorySelect(5)}  // Category ID 5 for Crypto
                                            >Crypto</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link" id="gaming-tab" data-bs-toggle="tab" data-bs-target="#gaming-tab-pane" type="button" role="tab" aria-controls="gaming-tab-pane" aria-selected="false"
                                                onClick={() => handleCategorySelect(6)}  // Category ID 6 for Gaming
                                            >Gaming</button>
                                        </li>
                                    </ul> */}
              </div>
            </div>
          </div>

          <div className="bottom-content">
            <div className="tab-content">
              <div
                className="tab-pane fade show active"
                role="tabpanel"
                aria-labelledby="home-tab"
                tabIndex="0"
              >
                <div className="parent-cards">
                  {tasks && tasks.length > 0 ? (
                    (history?.pathname === "/"
                      ? tasks.slice(0, visibleTasks)
                      : tasks
                    ).map((item, id) => (
                      <div className="single-card" key={id}>
                        <img
                          src="\assets\latesttask\right-bg-layer.png"
                          alt="img"
                          className="img-fluid right-bg-layer"
                        />
                        <div className="custom-container">
                          <div className="parent">
                            <div className="left-side">
                              <div className="main-content">
                                <div className="upper-inline-elem">

                                  <TaskStatus taskData={item} />
                                  <div className="single-elem">
                                    <h6>{item?.tasksCategory?.categoryName}</h6>
                                  </div>
                                  {item?.currency === "TASK" ? <div className="single-elem paid-design">
                                    <h6>Paid with <span>$TASK</span></h6>
                                  </div> : null}
                                </div>
                                <h6>{item?.title}</h6>
                                {/* <p>{item?.description}</p> */}
                                <div
                                  className=" ql-editor-new"
                                  // Uncomment the next line if using DOMPurify
                                  // dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                                  dangerouslySetInnerHTML={{
                                    __html: item?.description?.slice(0, 500),
                                  }}
                                />
                              </div>
                            </div>
                            <div className="right-side">
                              <div className="parent-box">
                                <div className="upper-area">
                                  <div className="first-div">
                                    <p>Participants</p>
                                    <div className="multi-imgs">
                                      <div className="imgs-parent">
                                        {item?.participants
                                          ?.slice(0, 4)
                                          .map((e, i) => {
                                            let classn;
                                            if (i == 0) {
                                              classn = "one";
                                            } else if (i == 1) {
                                              classn = "two";
                                            } else if (i == 2) {
                                              classn = "three";
                                            } else {
                                              classn = "four";
                                            }
                                            // if(i==3){
                                            //     return
                                            // }
                                            return (
                                              <img
                                                src={
                                                  e?.user?.imageUrl
                                                    ? e.user.imageUrl.startsWith(
                                                      "http"
                                                    )
                                                      ? e.user.imageUrl
                                                      : `https://${e.user.imageUrl}`
                                                    : "/assets/edituploadimg.png"
                                                }
                                                alt="participantimg"
                                                className="img-fluid"
                                              />
                                            );
                                          })}
                                        {/* <img src="\assets\dummy\profile.png" alt="img" className='img-fluid' />
                                      <img src="\assets\dummy\profile.png" alt="img" className='img-fluid' />
                                      <img src="\assets\dummy\profile.png" alt="img" className='img-fluid' />
                                      <img src="\assets\dummy\profile.png" alt="img" className='img-fluid' /> */}
                                      </div>
                                      {item?.participantCount > 4 && (
                                        <span>
                                          {item?.participantCount - 4}
                                        </span>
                                      )}
                                      {item?.participantCount === "0" && (
                                        <span>{item?.participantCount}</span>
                                      )}
                                      {item?.participants?.length === 0 &&
                                        item?.participantCount > 0 && (
                                          <span>{item?.participantCount}</span>
                                        )}
                                    </div>
                                  </div>
                                  <div className="first-div">
                                    <p>Created By</p>
                                    <h6>
                                      {item?.user?.imageUrl ? (
                                        <img
                                          src={
                                            item?.user?.imageUrl.startsWith(
                                              "http"
                                            )
                                              ? item.user.imageUrl
                                              : `https://${item.user.imageUrl}`
                                          }
                                          alt="img"
                                          className="img-fluid"
                                        />
                                      ) : null}
                                      {item?.user?.name
                                        ? item?.user?.name
                                        : item?.user?.walletAddress?.slice(
                                          0,
                                          5
                                        ) +
                                        "..." +
                                        item?.user?.walletAddress?.slice(-4)}
                                    </h6>
                                  </div>
                                  <div className="first-div">
                                    <p>Reward</p>
                                    <h6>
                                      <img
                                        src={tokenImages[item?.currencySymbol]}
                                        alt={item?.currencySymbol}
                                      />{" "}
                                      {
                                        parseFloat(item?.reward) > 1000
                                          ? parseFloat(
                                            item?.reward
                                          ).toLocaleString() // Format with commas if > 1000
                                          : Number(item?.reward) % 1 === 0
                                            ? parseFloat(item?.reward).toFixed(0) // No decimal places if it's an integer
                                            : parseFloat(item?.reward).toFixed(4) // Show 4 decimal places if it's a decimal
                                      }{" "}
                                      {item?.currencySymbol}
                                    </h6>
                                  </div>
                                  <div className="first-div">
                                    <p>TX HASH</p>
                                    <h6>
                                      <a
                                        target="_blank"
                                        href={`${item?.id > intitial_production_eth_id ? Environment?.trxHashUrl_Arb : Environment?.trxHashUrl}/tx/${item?.taskTransactionHash}`}
                                      >
                                        {item?.taskTransactionHash?.slice(0, 5)}
                                        ...
                                        {item?.taskTransactionHash?.slice(-2)}
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="21"
                                          viewBox="0 0 20 21"
                                          fill="none"
                                        >
                                          <path
                                            d="M8.33333 4.66667H6.83333C5.89991 4.66667 5.43285 4.66667 5.07633 4.84832C4.76273 5.00811 4.50795 5.2629 4.34816 5.5765C4.1665 5.93302 4.1665 6.40008 4.1665 7.3335V13.6668C4.1665 14.6003 4.1665 15.0667 4.34816 15.4232C4.50795 15.7368 4.76273 15.9921 5.07633 16.1519C5.43251 16.3333 5.899 16.3333 6.83059 16.3333H13.1691C14.1007 16.3333 14.5665 16.3333 14.9227 16.1519C15.2363 15.9921 15.4919 15.7366 15.6517 15.423C15.8332 15.0668 15.8332 14.6008 15.8332 13.6692V12.1667M16.6665 8V3.83334M16.6665 3.83334H12.4998M16.6665 3.83334L10.8332 9.66667"
                                            stroke="black"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                        </svg>
                                      </a>
                                    </h6>
                                  </div>
                                </div>
                                {item?.participants[0]?.status === "winner" ? (
                                  <Timer endTime={0} taskData={item} />
                                ) : (
                                  <Timer endTime={item?.endTime} taskData={item} />
                                )}
                                {/* <Timer endTime={item?.endTime} /> */}
                                {/* {((new Date(item?.endTime) > new Date()) && (userId != item?.userId) && !item?.hasParticipated ) && ( */}
                                <ConditionalLink
                                  href={`/similartaskdetail/${item?.id}`}
                                  className="btn-part"
                                >
                                  View Details
                                </ConditionalLink>
                                {/* )} */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <>
                      <div className="custom-container">
                        <div className="nodatafound">
                          <svg xmlns="http://www.w3.org/2000/svg" width="108" height="108" viewBox="0 0 108 108" fill="none">
                            <path d="M53.7501 29.5027L88 43.5027L95 51.7527L88 54.6651V88.7527L53.7501 102.503L19.2501 88.7527L19.8979 54.6651L13.0001 51.7527L20.0001 43.5027L53.7501 29.5027Z" fill="#F2F3F4" />
                            <path d="M20.0001 43.5027L53.7501 57.5027M20.0001 43.5027L53.7501 29.5027L88 43.5027M20.0001 43.5027L13.0001 51.7527L19.8979 54.6651M53.7501 57.5027L88 43.5027M53.7501 57.5027L46.7501 66.0027L19.8979 54.6651M53.7501 57.5027L60.7501 66.0027L88 54.6651M53.7501 57.5027V102.503M88 43.5027L95 51.7527L88 54.6651M88 54.6651V88.7527L53.7501 102.503M53.7501 102.503L19.2501 88.7527L19.8979 54.6651" stroke="#013159" />
                            <rect x="30.7499" y="13.0027" width="17.5" height="6.49999" rx="3.25" stroke="#013159" />
                            <path d="M42.611 25.9795C40.2208 25.9795 38.2246 24.3216 36.7807 22.5397C36.0682 21.6605 35.5128 20.7785 35.1354 20.1151C35.0563 19.976 34.9851 19.8468 34.9221 19.7295H45.1464C45.1561 19.9037 45.1653 20.1215 45.1696 20.371C45.1811 21.0343 45.1578 21.9098 45.0231 22.7779C44.8871 23.6545 44.6442 24.4767 44.2468 25.0677C43.8649 25.6356 43.3525 25.9795 42.611 25.9795ZM34.7801 12.5999C34.8283 12.4554 34.887 12.2896 34.9569 12.107C35.2168 11.4292 35.6299 10.5289 36.2427 9.63201C37.4662 7.84153 39.4555 6.09991 42.6111 6.09991C43.3449 6.09991 43.8573 6.45143 44.2427 7.04428C44.6426 7.65958 44.8865 8.51471 45.0229 9.42408C45.158 10.3246 45.1813 11.2323 45.1698 11.9197C45.1654 12.1856 45.1558 12.4169 45.1457 12.5999H34.7801Z" stroke="#013159" />
                            <path d="M52.0001 16.2527C52.0001 16.2527 77.7302 13.0027 77.0001 22.5027C77.0001 33.2527 60.8852 27.6196 56.0001 34.5027C51.6968 40.5661 53.7501 51.7526 53.7501 51.7526" stroke="#013159" stroke-linecap="round" stroke-dasharray="4 4" />
                          </svg>
                          <h6>Currently, there are no tasks in this category.</h6>
                          <p>Explore other categories for more options, or update your preferences to get notified when new tasks are added in categories relevant to your services.</p>
                          <div className="twice-btns">
                            <Link to="/latesttask" className="latest-btn">Explore Latest Tasks</Link>
                            {account && <Link to="/editprofile" className="update-btn">Update Category Preference</Link>}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {/* {console.log(visibleTasks, tasks.length, 'visibleTasks')
                  } */}
                  {((history?.pathname === "/") &&
                    (tasks.length > 3) &&
                    (visibleTasks < tasks.length)) ?
                    <div className="seeMore">
                      <button onClick={handleSeeMore}>See More</button>
                    </div>
                    : (history?.pathname === "/" && tasks.length >= 9) && <div className="seeMore">
                      <button onClick={() => navigate(categoryId ? `/latesttask?catId=${categoryId}` : '/latesttask')}>View All Tasks</button>
                    </div>}
                </div>
              </div>
            </div>
            <div className="paginationmain">
              {/* <div className="left-f">
          <h6>
                {" "}
                {count > 0 && count <= 5 ? (
                  <>
                    <p>
                      SHOWING 1-{count} OF {count}
                    </p>
                  </>
                ) : count > 5 ? (
                  <>
                    <p>
                      SHOWING {page > 0 ? page * 5 + 1 : page + 1} -
                      {5 * (page + 1) > count ? count : 5 * (page + 1)} OF{" "}
                      {count}
                    </p>
                  </>
                ) : (
                  <>
                    <p>SHOWING 0 OF 0</p>
                  </>
                )}
              </h6>
          </div> */}
              {pageCount > 1 && (
                <ReactPaginate
                  previousLabel={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <path
                        d="M10 13L5 8L10 3"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  }
                  nextLabel={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <path
                        d="M5 13L10 8L5 3"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  }
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  pageCount={pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageChange}
                  containerClassName="pagination"
                  activeClassName="active"
                  forcePage={page}
                ></ReactPaginate>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default LatestTask;

// import React, { useEffect, useState } from 'react'
// import "./latesttask.scss"
// import { Link, useLocation } from 'react-router-dom'
// import Navbar from '../header/Navbar';
// import Timer from './Timer';

// const LatestTask = () => {
//     const [tasks, setTasks] = useState([]);

//     const history = useLocation();
//     useEffect(() => {
//         window.scrollTo(0, 0)
//       }, [])
//     const getTasks = async ({ limit = 10, offset = 0, categoryId = null, orderField = 'createdAt', orderDirection = 'ASC' } = {}) => {
//         // Access token, either from state or local storage
//         const accessToken = localStorage.getItem('accessToken') || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Miwid2FsbGV0QWRkcmVzcyI6IjB4OGQyMzMzNmM1ZjcwNzU0YjMyNjFlNjBmYTM3ZThkOWYxOTA4NjRkYiIsImlhdCI6MTcyOTcwMjA4OSwiZXhwIjoxNzI5Nzg4NDg5LCJhdWQiOiIyIiwiaXNzIjoidG9taXRydXN0bGVzc3Jld2FyZHN5c3RlbS5jb20ifQ.ZEfK4vnis6Xr780gZddGdmbD8FttgNOs4yQyL9IQ558';  // Replace 'your-access-token' with the actual token source

//         // Construct query parameters
//         const queryParams = new URLSearchParams({
//             limit,
//             offset,
//             orderField,
//             orderDirection
//         });

//         if (categoryId) {
//             queryParams.append('categoryId', categoryId); // Only include if categoryId is provided
//         }

//         try {
//             const response = await fetch(`http://52.202.190.127:3000/tasks?${queryParams.toString()}`, {
//                 method: 'GET',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${accessToken}`  // Include the access token
//                 }
//             });

//             if (response.ok) {
//                 const data = await response.json();
//                 // console.log(data?.data);

//                 setTasks(data?.data); // Set tasks in state
//             } else {
//                 console.error('Failed to fetch tasks:', response.statusText);
//             }
//         } catch (error) {
//             console.error('Error occurred while fetching tasks:', error);
//         }
//     };

//     useEffect(() => {
//         // Example: Get 5 tasks, starting from offset 0, ordered by title in descending order
//         getTasks({ limit: 5, offset: 1, orderField: 'createdAt', orderDirection: 'ASC' });
//     }, []);
//     return (
//         <>
//             <div className="wrapper-latestsection">
//                 {
//                     history.pathname === '/latesttask' && <Navbar />
//                 }
//                 <section className={history.pathname === '/latesttask' ? "latest-task latesttask-section" : "latest-task"} id='latesttask'>
//                     <div className="custom-container">
//                         {
//                             history.pathname === '/latesttask' && <>
//                                 <div className="breadcrumb-text">
//                                     <Link to="/">Home</Link>
//                                     <span>/</span>
//                                     <Link to="/latesttask" className='active'>Tasks</Link>
//                                 </div>
//                             </>
//                         }
//                     </div>
//                     <div className="main-heading">
//                         <div className="custom-container">
//                             <div className="parent-head">
//                                 <h6>{history.pathname === '/latesttask' ? "Tasks" : "Latest Tasks"}</h6>
//                                 <Link to="/latesttask" className='btn-view'>View All Tasks</Link>
//                                 <div className="choice-bar">
//                                     <ul class="nav nav-tabs" id="myTab" role="tablist">
//                                         <li class="nav-item" role="presentation">
//                                             <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">All tasks</button>
//                                         </li>
//                                         <li class="nav-item" role="presentation">
//                                             <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">Music</button>
//                                         </li>
//                                         <li class="nav-item" role="presentation">
//                                             <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact-tab-pane" type="button" role="tab" aria-controls="contact-tab-pane" aria-selected="false">Marketing</button>
//                                         </li>
//                                         <li class="nav-item" role="presentation">
//                                             <button class="nav-link" id="design-tab" data-bs-toggle="tab" data-bs-target="#design-tab-pane" type="button" role="tab" aria-controls="design-tab-pane" aria-selected="false">Design</button>
//                                         </li>
//                                         <li class="nav-item" role="presentation">
//                                             <button class="nav-link" id="media-tab" data-bs-toggle="tab" data-bs-target="#media-tab-pane" type="button" role="tab" aria-controls="media-tab-pane" aria-selected="false">Media</button>
//                                         </li>
//                                         <li class="nav-item" role="presentation">
//                                             <button class="nav-link" id="crypto-tab" data-bs-toggle="tab" data-bs-target="#crypto-tab-pane" type="button" role="tab" aria-controls="crypto-tab-pane" aria-selected="false">Crypto</button>
//                                         </li>
//                                         <li class="nav-item" role="presentation">
//                                             <button class="nav-link" id="gaming-tab" data-bs-toggle="tab" data-bs-target="#gaming-tab-pane" type="button" role="tab" aria-controls="gaming-tab-pane" aria-selected="false">Gaming</button>
//                                         </li>
//                                     </ul>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="bottom-content">
//                         <div class="tab-content" id="myTabContent">
//                             <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0">
//                                 <div className="parent-cards">
//                                     {tasks?.tasks?.map((item, id)=>{

//                                   return ( <div className="single-card">
//                                         <img src="\assets\latesttask\right-bg-layer.png" alt="img" className='img-fluid right-bg-layer' />
//                                         <div className="custom-container">
//                                             <div className="parent">
//                                                 <div className="left-side">
//                                                     <div className="main-content">
//                                                       <h6>{item?.title}</h6>
//                                                       <p>{item?.description}</p>
//                                                     </div>
//                                                 </div>
//                                                 <div className="right-side">
//                                                     <div className="parent-box">
//                                                         <div className="upper-area">
//                                                             <div className="first-div">
//                                                                 <p>Reward</p>
//                                                                 <h6><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
//                                                                     <rect x="0.315789" y="0.315789" width="23.3684" height="23.3684" rx="11.6842" fill="#FF0083" />
//                                                                     <rect x="0.315789" y="0.315789" width="23.3684" height="23.3684" rx="11.6842" stroke="#F9F9F9" stroke-width="0.631579" />
//                                                                     <path d="M12.5003 6.46749C15.2079 6.46749 17.4151 8.59086 17.517 11.2492L19.8922 12.6944C19.9632 12.2837 20 11.8618 20 11.431C20 7.32699 16.6425 4 12.4997 4C8.35693 4 5 7.32752 5 11.4315C5 12.3201 5.15739 13.1728 5.44656 13.962C5.73253 14.7448 6.14761 15.4658 6.66619 16.1012L11.2577 13.307V19H13.6778V13.261L18.3381 16.0975C18.8561 15.4621 19.2707 14.7406 19.5561 13.9572L12.5056 9.66656L12.5003 9.66975L7.62494 12.6362C7.52944 12.2535 7.47875 11.8544 7.47875 11.4427C7.47875 8.69501 9.72702 6.46802 12.4997 6.46802L12.5003 6.46749ZM12.5003 12.5442L12.5051 12.5469L12.5003 12.5501V12.5437V12.5442Z" fill="white" />
//                                                               </svg> {item?.reward} {item?.currencySymbol}</h6>
//                                                             </div>
//                                                             <div className="first-div">
//                                                                 <p>Participants</p>
//                                                                 <div className="multi-imgs">
//                                                                     {/* <div className="imgs-parent">
//                                                                         <img src="\assets\dummy\profile.png" alt="img" className='img-fluid' />
//                                                                         <img src="\assets\dummy\profile.png" alt="img" className='img-fluid' />
//                                                                         <img src="\assets\dummy\profile.png" alt="img" className='img-fluid' />
//                                                                         <img src="\assets\dummy\profile.png" alt="img" className='img-fluid' />
//                                                                     </div> */}
//                                                                   <span>{item?.participantCount}</span>
//                                                                 </div>
//                                                             </div>
//                                                           {/* {(item?.user?.name || item?.user?.imgUrl) && <div className="first-div">
//                                                                 <p>Created By</p>
//                                                               <h6>{item?.user?.imgUrl ?  <img src={item?.user?.imgUrl} alt="img" className='img-fluid' /> : null}{item?.user?.name || 'Null'}</h6>
//                                                             </div>} */}
//                                                           <div className="first-div">
//                                                               <p>Created By</p>
//                                                               <h6>{item?.user?.imgUrl ? <img src={item?.user?.imgUrl} alt="img" className='img-fluid' /> : null}{item?.user?.name || '...'}</h6>
//                                                           </div>
//                                                         </div>
//                                                         <Timer endTime={item?.endTime} />
//                                                         <Link to="/similartaskdetail" className='btn-part'>Participate</Link>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>)
//                                     }
//                                 ) }
//                                 </div>
//                             </div>

//                         </div>

//                     </div>
//                 </section>
//             </div>
//         </>
//     )
// }

// export default LatestTask
